(function () {

  function initPasswordDownload(section) {
    const containers = section.querySelectorAll('.password-download__content');

    containers.forEach(container => {
      const password = container.dataset.password;
      const file = container.dataset.file;

      const form = container.querySelector('.password-download__form');
      const description = container.querySelector('.password-download__description');
      const input = container.querySelector('.password-download__input');
      const error = container.querySelector('.password-download__error');
      const success = container.querySelector('.password-download__success');
      const button = container.querySelector('.password-download__submit');

      if (!password || !button) return;

      const storageKey = 'download_unlocked_' + file;
      const expiryKey = storageKey + '_expiry';

      const now = Date.now();
      const expiry = localStorage.getItem(expiryKey);

      // Restore unlocked state
      if (localStorage.getItem(storageKey) && expiry && now < expiry) {
        form.classList.add('hidden');
        error.classList.add('hidden');
        success.classList.remove('hidden');
        if (description) {
            description.classList.add('hidden');
        }
      }

      function handleSubmit() {
        if (input.value === password) {
            form.classList.add('hidden');
            error.classList.add('hidden');
            success.classList.remove('hidden');

            if (description) {
                description.classList.add('hidden');
            }

            const expiresAt = Date.now() + (60 * 60 * 1000);

            localStorage.setItem(storageKey, 'true');
            localStorage.setItem(expiryKey, expiresAt);
        } else {
            error.classList.remove('hidden');
        }
      }

      button.addEventListener('click', handleSubmit);
    
      input.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleSubmit();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.password-download').forEach(section => {
      initPasswordDownload(section);
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    initPasswordDownload(e.target);
  });

})();